<template>
  <InfoPageLayout>
    <template #title>{{ t('title') }}</template>
    <p class="leading-7">{{ t('intro1') }}<br />{{ t('intro2') }}</p>
    <ul class="mt-7 list-disc space-y-7 pl-[37px] leading-7">
      <li>{{ t('reason1') }}</li>
      <li>{{ t('reason2') }}</li>
      <li>{{ t('reason3') }}</li>
    </ul>
    <p class="mt-10 pl-4">
      <a
        href="mailto:support@talkwall.uio.no"
        class="underline underline-offset-4 hover:text-tw-rust focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-tw-rust"
      >
        Support@talkwall.uio.no
      </a>
    </p>
  </InfoPageLayout>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  import InfoPageLayout from '@/components/landingpage/InfoPageLayout.vue'

  const { t } = useI18n({
    messages: {
      no: {
        title: 'Kontaktinformasjon',
        intro1: 'Har du spørsmål til Samtavla eller hvordan din institusjon kan ta Samtavla i bruk?',
        intro2: 'Send gjerne epost hvis du:',
        reason1: 'Finner feil eller har forslag til forbedringer',
        reason2: 'Trenger utkast til databehandleravtale',
        reason3: 'Har spørsmål om FEIDE tilgang',
      },
      en: {
        title: 'Contact information',
        intro1: 'Do you have questions about Talkwall, or about how your institution can start using Talkwall?',
        intro2: 'Feel free to send us an email if you:',
        reason1: 'Find errors or have suggestions for improvements',
        reason2: 'Need a draft data processing agreement',
        reason3: 'Have questions about FEIDE access',
      },
    },
  })
</script>
